export const facturaGradient = "linear-gradient(110deg, #1e293b 0%, #0b4f6c 100%)";
export const facturaActionSx = {
  width: 32,
  height: 32,
  borderRadius: 2,
  border: "1px solid",
  borderColor: "currentColor",
  "& .MuiSvgIcon-root": { fontSize: 18 },
  "&.Mui-disabled": { color: "#94a3b8", borderColor: "#e2e8f0", bgcolor: "#f8fafc" },
};
export const facturaTableSx = {
  overflowX: "auto",
  "& table": { minWidth: 1400 },
  "& thead th": { bgcolor: "background.default", py: 1.5 },
  "& thead th > div": { opacity: 1, color: "text.primary", fontSize: 11, fontWeight: 700 },
  "& tbody td": { py: 1.5, px: 1.5, color: "text.primary", fontSize: 13, verticalAlign: "middle" },
  "& tbody td > div": { color: "text.primary", fontSize: 13 },
  "& tbody tr:nth-of-type(even)": { bgcolor: "action.hover" },
  "& tbody tr:hover": { bgcolor: "action.selected" },
};

export const facturaDialogSx = {
  borderRadius: 3,
  "& .MuiDialogTitle-root": { py: 2, px: 3 },
  "& .MuiTypography-h4": { fontSize: 22 },
  "& .MuiTypography-h5": { fontSize: 18 },
  "& .MuiTypography-h6": { fontSize: 16 },
  "& .MuiOutlinedInput-root": { minHeight: 48, borderRadius: 2 },
  "& .MuiInputBase-input": { fontSize: 14, color: "text.primary" },
  "& .MuiDialogActions-root": { px: 3, py: 2, borderTop: "1px solid", borderColor: "divider" },
  "& .MuiDialogActions-root button": { minHeight: 40, borderRadius: 2, textTransform: "none" },
};
